import React, { useEffect, useState } from 'react';
interface Question {
  id: number;
  text: string;
  options: {
    text: string;
    points: number;
  }[];
}
interface DiagnosticProps {
  question: Question;
  questionIndex: number;
  totalQuestions: number;
  onAnswer: (points: number) => void;
}
export function Diagnostic({
  question,
  questionIndex,
  totalQuestions,
  onAnswer
}: DiagnosticProps) {
  const [selectedOption, setSelectedOption] = useState<number | null>(null);
  useEffect(() => {
    setSelectedOption(null);
  }, [question.id]);
  const handleOptionClick = (points: number, index: number) => {
    if (selectedOption !== null) return;
    setSelectedOption(index);
    setTimeout(() => {
      onAnswer(points);
    }, 350);
  };
  const steps = Array.from({
    length: totalQuestions
  }, (_, i) => i);
  const progressWidth = `${(questionIndex + 1) / totalQuestions * 100}%`;
  return <div style={{
    display: 'flex',
    flexDirection: 'column',
    gap: '2rem'
  }} data-id="element-19">
      {/* Step Visual Indicator */}
      <div style={{
      display: 'flex',
      flexDirection: 'column',
      gap: '1rem'
    }} data-id="element-20">
        <div style={{
        display: 'flex',
        gap: '1.25rem',
        alignItems: 'flex-end'
      }} aria-label={`Step ${questionIndex + 1} of ${totalQuestions}`} data-id="element-21">
          {steps.map(stepIdx => {
          const isActive = stepIdx === questionIndex;
          const stepLabel = String(stepIdx + 1).padStart(2, '0');
          return <div key={stepIdx} style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            gap: '6px',
            cursor: 'default'
          }} data-id="element-22">
                <span style={{
              fontSize: '0.875rem',
              fontWeight: 500,
              color: isActive ? '#1A1A1A' : '#8A8A85',
              transition: 'color 150ms ease'
            }} data-id="element-23">
                  {stepLabel}
                </span>
                <div style={{
              height: '2px',
              width: '100%',
              backgroundColor: isActive ? '#C8102E' : 'transparent',
              transition: 'background-color 150ms ease',
              borderRadius: '1px'
            }} data-id="element-24" />
              </div>;
        })}
        </div>

        <p style={{
        fontSize: '0.875rem',
        fontWeight: 500,
        color: '#8A8A85'
      }} data-id="element-25">
          Question {questionIndex + 1} of {totalQuestions}
        </p>
        <div className="progress-track" data-id="element-26">
          <div className="progress-fill" style={{
          width: progressWidth
        }} data-id="element-27" />
        </div>
      </div>

      <h2 style={{
      fontSize: 'clamp(1.5rem, 3.5vw, 1.875rem)',
      fontWeight: 600,
      lineHeight: '1.2'
    }} data-id="element-28">
        {question.text}
      </h2>

      <div style={{
      display: 'flex',
      flexDirection: 'column',
      gap: '0.75rem'
    }} role="group" aria-label={`Question ${questionIndex + 1} options`} data-id="element-29">
        {question.options.map((option, idx) => <button key={idx} onClick={() => handleOptionClick(option.points, idx)} disabled={selectedOption !== null} className={`option-btn ${selectedOption === idx ? 'selected' : ''}`} aria-label={option.text} data-id="element-30">
            {option.text}
          </button>)}
      </div>
    </div>;
}